import React from "react";
import ActivitiesTicketScreen from "../../../common/AllTickets/Activities/ActivitiesTicketScreen";

function SuperActivitiesTicket() {
  return <ActivitiesTicketScreen mode="ADMIN" />;
}

export default SuperActivitiesTicket;
